import React from 'react';
import {useField} from 'formik';
import {CremaTheme} from '../../types/AppContextPropsType';
import {makeStyles} from '@material-ui/core';
import TextField from '@material-ui/core/TextField/TextField';

export const InputTextField = (props: any): React.ReactElement => {
  const useStyles = makeStyles((theme: CremaTheme) => ({
    crInput: {
      width: '100%',
      height: '100%',
      borderRadius: theme.overrides.MuiCard.root.borderRadius,
      backgroundColor: 'white',
      '& .MuiFormHelperText-root': {
        textAlign: 'center',
        padding: '0 10px',
        margin: 0,
      },
      '& input[type="text"], & input[type="number"]': {
        color: 'black',
        padding: '12px 16px',
        [theme.breakpoints.up('xl')]: {
          padding: '12px',
        },
      },
    },
  }));
  const classes = useStyles();

  const [field, meta] = useField(props);

  const errorText = meta.error && meta.touched ? meta.error : '';

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    if (props.onChange) {
      props.onChange(e.target.value);
    }
  };

  return (
    <TextField
      className={classes.crInput}
      {...props}
      {...field}
      helperText={errorText}
      error={!!errorText}
      onChange={onInputChange}
    />
  );
};
